// extracted by mini-css-extract-plugin
module.exports = {"scrollBars":"Events_scrollBars__QfvG2"};